import { IntegrationCredentialSecret } from '../models/integrationCredential';
import { integrationCredentialTestResultSchema } from '../models/integrationCredential.schema';
import { testIntegrationCredentialPayloadSchema } from './test.schema';

export type TestIntegrationCredentialPayload = {
  type: string;
  secret: IntegrationCredentialSecret;
};

/** Tests credentials that haven't been saved yet. */
export const test = (payload: TestIntegrationCredentialPayload) => {
  return {
    endpoint: `/integration_credentials/test`,
    method: 'POST',
    payload,
    responseSchema: integrationCredentialTestResultSchema,
    payloadSchema: testIntegrationCredentialPayloadSchema,
  } as const;
};
